import { api } from './client';
import type {
  Project,
  ProjectListItem,
  CreateProjectRequest,
  PaginatedResponse,
  FileNode,
  ProjectStats,
} from '@/types';

export interface UpdateProjectRequest {
  name?: string;
  description?: string;
  visibility?: string;
}

export const projectsApi = {
  list: (page = 1, pageSize = 20) =>
    api.get<PaginatedResponse<ProjectListItem>>(`/api/projects?page=${page}&pageSize=${pageSize}`),

  get: (slug: string) =>
    api.get<Project>(`/api/projects/${slug}`),

  create: (data: CreateProjectRequest) =>
    api.post<Project>('/api/projects', data),

  update: (slug: string, data: UpdateProjectRequest) =>
    api.put<Project>(`/api/projects/${slug}`, data),

  delete: (id: string) =>
    api.delete(`/api/projects/${id}`),

  start: (slug: string) =>
    api.post(`/api/projects/${slug}/start`),

  stop: (slug: string) =>
    api.post(`/api/projects/${slug}/stop`),

  restart: (slug: string) =>
    api.post(`/api/projects/${slug}/restart`),

  rebuild: (slug: string) =>
    api.post(`/api/projects/${slug}/rebuild`),

  getLogs: (slug: string, tail = 100) =>
    api.get<{
      containerId: string;
      serviceName: string;
      logs: Array<{
        timestamp: string;
        stream: string;
        message: string;
      }>;
      since?: string;
      until?: string;
    }>(`/api/projects/${slug}/logs?tail=${tail}`),

  getFiles: (slug: string, path = '/') =>
    api.get<FileNode[]>(`/api/projects/${slug}/files?path=${encodeURIComponent(path)}`),

  getFileContent: (slug: string, path: string) =>
    api.get<{ content: string }>(`/api/projects/${slug}/files/content?path=${encodeURIComponent(path)}`),

  checkSlugAvailability: (slug: string) =>
    api.get<{ available: boolean }>(`/api/projects/check-slug/${slug}`),

  getStats: (slug: string) =>
    api.get<ProjectStats>(`/api/projects/${slug}/stats`),

  getStatus: (slug: string) =>
    api.get<{
      projectStatus: string;
      containers: Array<{
        name: string;
        status: string;
        health?: string;
      }>;
    }>(`/api/projects/${slug}/status`),
};
